import { FC } from 'react';
import { DeviceFunctionsView } from './device-functions-view';
import { NotificationsView } from './notifications-view';
import { CurrentAddressBooksView } from '../address-book/current-address-books-view';

export const ConfigurationPanel: FC = () => (
  <>
    <div className="pt-4">
      <DeviceFunctionsView />
    </div>
    <div className="pt-14">
      <NotificationsView />
    </div>
    <div className="pt-14">
      <CurrentAddressBooksView />
    </div>
  </>
);
